import { Steps } from "antd-mobile";
import { Form } from "formsy-semantic-ui-react";
import * as R from "ramda";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { Button, Confirm, Label } from "semantic-ui-react";
import { getEventBySlug } from "../../api/async/events";
import { getAccountDetail } from "../../api/sync/index";
import { postOrder } from "../../api/sync/races/index";
import { Loader } from "../../components/Loader";
import MailingAddressPresentation from "../../components/MailingAddress/index";
import { SelectAddon } from "../../components/ShirtAddon";
import { endEvent } from "../../utils";
import { notification } from "antd";

class OrderEvent extends Component {
  state = {
    activeIndex: 0,
    confirmOpen: false,
    country: "Thailand",
    selected_shirt: [],
    disableSubmit: false
  };

  componentDidMount = async () => {
    const slug = this.props.match.params.slug;

    const res = await getEventBySlug(slug);
    this.setState({ event: res.data });

    if (endEvent(res.data)) {
      this.props.history.push("/me");
      notification.warning({
        message: `ของสะสมนี้ ${res.data.title} ปิดการสั่งซื้อแล้ว`
      });
    }

    getAccountDetail().then(res => {
      this.setState({ ...R.filter(R.identity, res.data) });
      const { postal_code } = res.data;
      if (postal_code) {
        this.setState({ postal_code: parseInt(postal_code) });
      }
    });
  };

  handleClickAccordian = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  onClickNext = () => {
    this.setState({ confirmOpen: false });
    this.setState({ activeIndex: this.state.activeIndex + 1 });
  };

  onClickBack = () => {
    this.setState({ activeIndex: this.state.activeIndex - 1 });
  };

  openConfirmOpen = () => {
    this.setState({ confirmOpen: true });
  };

  handleSubmit = () => {
    if (!this.state.disableSubmit) {
      this.setState({ disableSubmit: true });
      postOrder(this.state).then(res => {
        if (res.status <= 201) {
          this.setState({ disableSubmit: false });
          this.props.history.push(`/orders/${res.data.id}`);
        }
      });
    }
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  setNumberOfAddon = (name, value) => {
    const selectedAddons = this.state[name] || [];
    this.setState({ [name]: selectedAddons.splice(0, value) });
  };

  handleNumberOfAddonChange = (e, { name, value }) => {
    const addonType = name.split("numberOf")[1];
    if (this.state[`numberOf${addonType}`] > value) {
      this.setNumberOfAddon(`selected_${addonType}`, value);
    }

    if (value.toString().startsWith("no_")) {
      this.setState({ [`numberOf${addonType}`]: 0 });
      this.setState({ [`selected_${addonType}`]: [] });
      return;
    }
    if (this.state.event.addons.length === 1) {
      this.setState({
        [`selected_${addonType}`]: Array(value).fill(
          this.state.event.addons[0].id
        )
      });
    }
    this.setState({ [name]: value });
  };

  handleRadioChange = (e, type) => {
    const selected = this.state[`selected_${type}`] || [];
    const addonId = e.target.value;
    const selectAddonIndex = e.target.selectAddonIndex;

    selected[selectAddonIndex] = addonId;
    this.setState({ [e.target.name]: selected });
  };

  handleAddressSelect = address => {
    this.setState({ province: address.p });
    this.setState({ sub_district: address.d });
    this.setState({ district: address.a });
    this.setState({ postal_code: address.z });
  };

  render() {
    const { activeIndex, event } = this.state;
    const errorLabel = <Label color="red" pointing />;
    return event ? (
      <React.Fragment>
        <Steps direction="horizontal" current={activeIndex} size="small">
          <Steps.Step className="mobile-step" />
          <Steps.Step className="mobile-step" />
        </Steps>
        <div style={{ display: activeIndex === 0 ? "block" : "none" }}>
          <Form
            id="first-step"
            onValidSubmit={this.onClickNext}
            onValid={this.enableButton}
            onInvalid={this.disableButton}
          >
            {event.addons && (
              <React.Fragment>
                <SelectAddon
                  addons={event.addons}
                  handleChange={this.handleNumberOfAddonChange}
                  handleRadioChange={this.handleRadioChange}
                  numberOf={this.state[`numberOf${event.addons[0].type}`]}
                  type={event.addons[0].type}
                  race={event}
                />
                {R.pathOr(false, ["engrave"], this.state.event) && (
                  <React.Fragment>
                    <h3>สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)</h3>
                    <Form.Group>
                      <Form.Input
                        validations="maxLength:12"
                        name="engrave"
                        className="mb10"
                        style={{ width: "350px", marginBottom: "10px" }}
                        value={this.state.engrave}
                        validationErrors={{
                          maxLength: "โปรดกรอกไม่เกิน 12 ตัวอักษร"
                        }}
                        placeholder="สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)"
                        onChange={this.handleChange}
                        errorLabel={errorLabel}
                      />
                    </Form.Group>
                  </React.Fragment>
                )}
                <div>
                  <Button
                    {...(!this.state[`numberOf${event.addons[0].type}`] && {
                      disabled: true
                    })}
                    color="teal"
                    type="submit"
                    form="first-step"
                    style={{ marginTop: "10px" }}
                  >
                    ต่อไป
                  </Button>
                </div>
              </React.Fragment>
            )}
          </Form>
        </div>
        <div
          style={{
            display: activeIndex === 1 ? "block" : "none"
          }}
        >
          <h3>ที่อยู่สำหรับจัดส่งของ</h3>
          <MailingAddressPresentation
            firstname={this.state.firstname}
            lastname={this.state.lastname}
            address_1={this.state.address_1}
            sub_district={this.state.sub_district}
            district={this.state.district}
            province={this.state.province}
            country={this.state.country}
            showPhoneNumber
            postal_code={this.state.postal_code}
            phone_number={this.state.phone_number}
            handleChange={this.handleChange}
            handleAddressSelect={this.handleAddressSelect}
            onClickBack={this.onClickBack}
            onClickNext={this.openConfirmOpen}
          />
        </div>

        <Confirm
          open={this.state.confirmOpen}
          cancelButton="แก้ไข"
          confirmButton="ตกลง"
          content="กรุณาตรวจสอบข้อมูลการจัดส่งให้เรียบร้อย หลังจากชำระเงินแล้วจะไม่สามารถเปลี่ยนที่อยู่สำหรับจัดส่งได้"
          onCancel={() => this.setState({ confirmOpen: false })}
          onConfirm={this.handleSubmit}
        />
      </React.Fragment>
    ) : (
      <Loader />
    );
  }
}

export default withRouter(OrderEvent);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/OrderEvent/index.js